import { format } from 'date-fns';
import { HttpClient } from "@angular/common/http";
import { Component, OnInit } from "@angular/core";
import { UntypedFormBuilder } from "@angular/forms";
import { Router } from "@angular/router";
import { AngularCsv } from "angular-csv-ext/dist/Angular-csv";
import { NzModalService } from "ng-zorro-antd/modal";
import { Modules, Responsibility } from "shared/models";
import {
  NotificationTemplateConfiguration,
  NotificationTemplateConfigurationExport,
  WhatsAppTemplateList,
} from "shared/models";
import { AlertMessageService } from "shared/core";
import { AuthService } from "shared/core";
import { LoggingService } from "shared/core";
import { environment } from "src/environments/environment";
import * as cronstrue from "cronstrue";

@Component({
    selector: "app-notification-type-configuration",
    templateUrl: "./notification-type-configuration.component.html",
    styleUrls: ["./notification-type-configuration.component.css"],
    standalone: false
})
export class NotificationTypeConfigurationComponent implements OnInit {
  WhatsAppTemplateList: WhatsAppTemplateList[] = [];

  constructor(
    public http: HttpClient,
    private alertService: AlertMessageService,
    private modalService: NzModalService,
    private auth: AuthService,
    private router: Router,
    private fb: UntypedFormBuilder,
    private logger: LoggingService
  ) { }

  permission = {
    View: false,
    Add: false,
    Edit: false,
    Delete: false,
  };

  ApiUrl = environment.Api_Url;

  PopUpTitle: string = "Add New Configuration";
  searchValue = "";
  IsSearching = false;
  isTableLoading: boolean = false;
  isVisible = false;
  isLoading: boolean = false;
  isShownEdit: boolean = false;
  ConfigurationTitle: string = "";
  IsSubTypeVisible: boolean = false;

  NotificationConfigurationList: NotificationTemplateConfiguration[] = [];
  NotificationConfigurationListOriginal: NotificationTemplateConfiguration[] = [];
  NotificationConfigurationListExport: NotificationTemplateConfigurationExport[] = [];
  exportfields: NotificationTemplateConfigurationExport[] = [];
  exportoptions = {
    headers: [
      "Category Type",
      "Notification Type",
      "Sub Type",
      "Display Name",
      "Description",
      "Internal Allowed",
      "External Allowed",
      "Customer Allowed",
      "Event Allowed",
      "Scheduling Allowed",
      "On-Demand Allowed",
      "Scheduling Required",
      "WhatsApp Template",
      "Added By",
      "Added Date",
    ],
  };

  NewNotificationConfiguration: NotificationTemplateConfiguration = new NotificationTemplateConfiguration();

  fields: NotificationTemplateConfigurationExport = new NotificationTemplateConfigurationExport();
  count: number = 0;

  // =====================================================
  // DROPDOWN OPTIONS - Separate from table data
  // =====================================================

  // Category Type options (Level 1)
  categoryTypeOptions = [
    { value: 'Inventory', label: 'Inventory Management' },
    { value: 'Production', label: 'Production Management' },
    { value: 'Costing', label: 'Cost Management' },
    { value: 'Procurement', label: 'Procurement Management' }
  ];

  // Notification Type options per category (Level 2)
  notificationTypeOptions = {
    'Inventory': [
      { value: 'LowStock', label: 'Low Stock Alerts' },
      { value: 'ReturnableOutPassReminder', label: 'Returnable Out Pass Reminder' },
      { value: 'StockMovement', label: 'Stock Movement Alerts' },
      { value: 'Cancelled', label: 'GRN Cancelled' },
      { value: 'PartiallyAccepted', label: 'GRN Partially Accepted' },
      { value: 'Rejected', label: 'GRN Rejected' },
      { value: 'Reports', label: 'Reports & Analytics' }
    ],
    'Production': [
      { value: 'OrderStatus', label: 'Order Status Updates' },
      { value: 'MachineAlert', label: 'Machine Alerts' },
      { value: 'QualityAlert', label: 'Quality Alerts' },
      { value: 'Reports', label: 'Reports & Analytics' }
    ],
    'Costing': [
      { value: 'OverheadCostUpdateReminder', label: 'Overhead Cost Updates Reminder' },
      { value: 'BudgetAlert', label: 'Budget Alerts' },
      { value: 'Reports', label: 'Reports & Analytics' }
    ],
    'Procurement': [
      { value: 'PurchaseOrderApproval', label: 'Purchase Order Approval' },
      { value: 'DeliveryDelay', label: 'Purchase Order Delivery Delay' },
      { value: 'Reports', label: 'Reports & Analytics' }
    ]
  };

  subTypeOptions = {
    'Inventory-Reports': [
      { value: 'LowStockReport', label: 'Low Stock Report' },
      { value: 'ReturnableOutPassReport', label: 'Returnable Out Pass Report' },
      { value: 'InventoryValuationReport', label: 'Inventory Valuation Report' },
      { value: 'StockMovementReport', label: 'Stock Movement Report' }
    ],
    'Production-Reports': [
      { value: 'YieldReportSummary', label: 'Yield Report Summary' },
      { value: 'ProductionSummary', label: 'Production Summary' },
      { value: 'JumboSummary', label: 'Jumbo Summary' },
      { value: 'ProductionEfficiencyReport', label: 'Production Efficiency Report' },
      { value: 'WIPReport', label: 'Work In Progress Report' },
      { value: 'QualityControlReport', label: 'Quality Control Report' }
    ],
    'Production-OrderStatus': [
      { value: 'OrderCreated', label: 'Order Created' },
      { value: 'ProductionStarted', label: 'Production Started' },
      { value: 'ProductionCompleted', label: 'Production Completed' },
      { value: 'QualityCheckPending', label: 'Quality Check Pending' }
    ],
    'Production-MachineAlert': [
      { value: 'MaintenanceDue', label: 'Maintenance Due' },
      { value: 'BreakdownAlert', label: 'Breakdown Alert' }
    ],
    'Costing-Reports': [
      { value: 'ExecutiveCostingReport', label: 'Executive Cost Analysis Report' },
      { value: 'OverheadVarianceReport', label: 'Overhead Variance Report' },
      { value: 'ProfitabilityReport', label: 'Profitability Analysis Report' },
      { value: 'BudgetVarianceReport', label: 'Budget Variance Report' }
    ],
    'Procurement-PurchaseOrderApproval': [
      { value: 'PendingApproval', label: 'Purchase Order Pending Approval' },
      { value: 'Approved', label: 'Purchase Order Approved' },
      { value: 'Rejected', label: 'Purchase Order Rejected' }
    ],
    'Procurement-Reports': [
      { value: 'PurchaseOrderSummaryReport', label: 'Purchase Order Summary Report' },
      { value: 'PurchaseOrderApprovalReport', label: 'Purchase Order Approval Report' },
      { value: 'PurchaseOrderAutoCleanupReport', label: 'Purchase Order Auto Clean-Up Report' }
    ]
  };

  ngOnInit(): void {
    this.permission.View = this.auth.CheckResponsibility(
      Modules.NotificationTypeConfiguration,
      Responsibility.View
    );
    this.permission.Add = this.auth.CheckResponsibility(
      Modules.NotificationTypeConfiguration,
      Responsibility.Add
    );
    this.permission.Edit = this.auth.CheckResponsibility(
      Modules.NotificationTypeConfiguration,
      Responsibility.Edit
    );
    this.permission.Delete = this.auth.CheckResponsibility(
      Modules.NotificationTypeConfiguration,
      Responsibility.Delete
    );

    if (this.permission.View != true) {
      this.router.navigate(["/home/unauthorized"]);
    }
    this.GetAllNotificationConfigurations();
  }

  GetAllNotificationConfigurations() {
    this.isTableLoading = true;
    let url = this.ApiUrl + "notificationconfig/getnotificationtemplateconfigurations";

    this.logger.api("request", "notificationconfig/getnotificationtemplateconfigurations", { operation: "GetAllNotificationConfigurations" });

    this.http.get<NotificationTemplateConfiguration[]>(url).subscribe(
      (res) => {
        res.forEach((item, index) => {
          item.SerialNumber = index + 1;
        });

        this.NotificationConfigurationList = res;
        this.NotificationConfigurationListOriginal = res;
        this.isTableLoading = false;
        this.exportfields = [];

        this.NotificationConfigurationListExport.forEach((x) => {
          this.fields = new NotificationTemplateConfigurationExport();

          this.fields.CategoryType = x.CategoryType;
          this.fields.NotificationType = x.NotificationType;
          this.fields.SubType = x.SubType;
          this.fields.DisplayName = x.DisplayName;
          this.fields.Description = x.Description;
          this.fields.InternalAllowed = x.InternalAllowed ? "Yes" : "No";
          this.fields.ExternalAllowed = x.ExternalAllowed ? "Yes" : "No";
          this.fields.CustomerAllowed = x.CustomerAllowed ? "Yes" : "No";
          this.fields.EventAllowed = x.EventAllowed ? "Yes" : "No";
          this.fields.SchedulingAllowed = x.SchedulingAllowed ? "Yes" : "No";
          this.fields.OnDemandAllowed = x.OnDemandAllowed ? "Yes" : "No";
          this.fields.SchedulingRequired = x.SchedulingRequired ? "Yes" : "No";
          this.fields.WhatsAppTemplateName = x.WhatsAppTemplateName;
          this.fields.AddedBy = x.AddedBy;
          this.fields.AddedDate = x.AddedDate;

          this.exportfields.push(this.fields);
        });

        this.logger.api("response", "notificationconfig/getnotificationtemplateconfigurations", {
          status: 200,
          count: res.length
        });
      },
      (error) => {
        this.count++;
        this.logger.api("error", "notificationconfig/getnotificationtemplateconfigurations", {
          error,
          attempt: this.count
        });
        if (this.count < 2) {
          this.GetAllNotificationConfigurations();
        } else {
          this.isTableLoading = false;
          this.alertService.error("Failed to load notification configurations. Please try again.");
        }
      }
    );
  }

  onKeydown(event: any) {
    if (
      (event.target.selectionStart === 0 && event.code === "Space") ||
      (event.key === "Enter" && event.keyCode === 13)
    ) {
      event.preventDefault();
      event = this.search();
    }
  }

  ValidateText() {
    this.searchValue.trim();
    this.searchValue = this.searchValue.trim();
  }

  search() {
    var res = this.NotificationConfigurationListOriginal;
    this.NotificationConfigurationList = res.filter((item: NotificationTemplateConfiguration) => {
      if (
        item?.CategoryType?.toLowerCase().includes(
          this.searchValue?.toLowerCase()
        )
      ) {
        return true;
      } else if (
        item?.SubType?.toLowerCase().includes(this.searchValue?.toLowerCase())
      ) {
        return true;
      } else if (
        item?.DisplayName?.toLowerCase().includes(this.searchValue?.toLowerCase())
      ) {
        return true;
      } else if (
        item?.AddedBy?.toLowerCase().includes(this.searchValue?.toLowerCase())
      ) {
        return true;
      }
      return false;
    });
  }

  reset(): void {
    this.searchValue = "";
    this.search();
  }

  export() {
    var exportdate = format(new Date(), "-ddMMyyyy-hhmmss");
    if (this.exportfields.length > 0)
      new AngularCsv(
        this.exportfields,
        "notification-configuration-export" + exportdate,
        this.exportoptions
      );
  }

  handleDelete(data: NotificationTemplateConfiguration) {
    const modal = this.modalService.confirm({
      nzTitle: "Confirm",
      nzContent: "Are you sure to delete this notification configuration?",
      nzOkDanger: true,
      nzOkText: "Yes",
      nzOnOk: () => this.DeleteNotificationConfiguration(data),
    });
    setTimeout(() => modal.destroy(), 5000);
  }

  DeleteNotificationConfiguration(data: NotificationTemplateConfiguration) {
    let url = this.ApiUrl + `notificationconfig/deletenotificationtemplateconfig`;

    this.logger.api("request", `notificationconfig/deletenotificationtemplateconfig`, {
      operation: "DeleteNotificationConfiguration",
      configurationId: data.ConfigurationId
    });

    this.http.post<any>(url, data.ConfigurationId).subscribe({
      next: res => {
        this.alertService.success("Configuration deleted successfully");
        this.isLoading = false;
        this.GetAllNotificationConfigurations();
        this.logger.api("response", `notificationconfig/deletenotificationtemplateconfig`, {
          status: 200,
          configurationId: data.ConfigurationId
        });
      },
      error: res => {
        this.logger.api("error", `notificationconfig/deletenotificationtemplateconfig`, {
          error: res,
          configurationId: data.ConfigurationId
        });
        if (res.status == 400) {
          this.alertService.warning(res.error)
        }
        else {
          this.alertService.error("An error occurred while deleting the configuration");
          this.isLoading = false;
        }
      },
    });
  }

  handleOk(): void {
    this.isLoading = true;
    this.SaveNotificationConfiguration();
  }

  SaveNotificationConfiguration() {
    if (!this.Validate(this.NewNotificationConfiguration)) {
      this.isLoading = false;
      return;
    }

    if (this.isShownEdit) {
      let url = this.ApiUrl + "notificationconfig/updatenotificationtemplateconfig";

      this.logger.api("request", "notificationconfig/updatenotificationtemplateconfig", {
        operation: "UpdateNotificationConfiguration",
        configurationId: this.NewNotificationConfiguration.ConfigurationId
      });

      this.http.post<any>(url, this.NewNotificationConfiguration).subscribe({
        next: (res) => {
          this.alertService.success("Configuration updated successfully");
          this.isLoading = this.isVisible = false;
          this.GetAllNotificationConfigurations();
          this.logger.api("response", "notificationconfig/updatenotificationtemplateconfig", {
            status: 200,
            configurationId: this.NewNotificationConfiguration.ConfigurationId
          });
        },
        error: (res) => {
          this.logger.api("error", "notificationconfig/updatenotificationtemplateconfig", {
            error: res,
            configurationId: this.NewNotificationConfiguration.ConfigurationId
          });
          this.alertService.error("An error occurred while updating the configuration");
          this.isLoading = this.isVisible = false;
        },
      });
    } else {
      let url = this.ApiUrl + "notificationconfig/addnotificationtemplateconfig";

      this.logger.api("request", "notificationconfig/addnotificationtemplateconfig", {
        operation: "AddNotificationConfiguration",
        categoryType: this.NewNotificationConfiguration.CategoryType
      });

      this.http.post<any>(url, this.NewNotificationConfiguration).subscribe({
        next: (res) => {
          this.alertService.success("Configuration added successfully");
          this.isLoading = this.isVisible = false;
          this.GetAllNotificationConfigurations();
          this.logger.api("response", "notificationconfig/addnotificationtemplateconfig", {
            status: 200,
            categoryType: this.NewNotificationConfiguration.CategoryType
          });
        },
        error: (res) => {
          this.logger.api("error", "notificationconfig/addnotificationtemplateconfig", {
            error: res,
            categoryType: this.NewNotificationConfiguration.CategoryType
          });
          this.alertService.error("An error occurred while adding the configuration");
          this.isLoading = this.isVisible = false;
        },
      });
    }
  }



  showModal(): void {
    this.ConfigurationTitle = "Add New Notification Configuration";
    this.isVisible = true;
    this.isShownEdit = false;

    // Ensure complete form isolation
    this.resetForm();
    this.ensureFormIsolation();

    this.GetAllWhatsAppTemplateList();

    this.logger.debug('Add modal opened with clean form state');
  }

  editConfiguration(value: NotificationTemplateConfiguration) {
    if (value.ConfigurationId) {
      this.ConfigurationTitle = "Edit Notification Configuration";
      this.isVisible = true;
      this.isShownEdit = true;

      // Create a deep copy to ensure complete isolation from table data
      this.NewNotificationConfiguration = new NotificationTemplateConfiguration();
      this.NewNotificationConfiguration.ConfigurationId = value.ConfigurationId;
      this.NewNotificationConfiguration.CategoryType = value.CategoryType || "";
      this.NewNotificationConfiguration.NotificationType = value.NotificationType || "";
      this.NewNotificationConfiguration.SubType = value.SubType || "";
      this.NewNotificationConfiguration.DisplayName = value.DisplayName || "";
      this.NewNotificationConfiguration.Description = value.Description || "";
      this.NewNotificationConfiguration.InternalAllowed = value.InternalAllowed ?? true;
      this.NewNotificationConfiguration.ExternalAllowed = value.ExternalAllowed ?? false;
      this.NewNotificationConfiguration.CustomerAllowed = value.CustomerAllowed ?? false;
      this.NewNotificationConfiguration.EventAllowed = value.EventAllowed ?? true;
      this.NewNotificationConfiguration.SchedulingAllowed = value.SchedulingAllowed ?? false;
      this.NewNotificationConfiguration.OnDemandAllowed = value.OnDemandAllowed ?? true;
      this.NewNotificationConfiguration.SchedulingRequired = value.SchedulingRequired ?? false;
      this.NewNotificationConfiguration.SortOrder = value.SortOrder || 0;
      this.NewNotificationConfiguration.WhatsAppTemplateMasterId = value.WhatsAppTemplateMasterId;
      this.NewNotificationConfiguration.PushNotificationAllowed = value.PushNotificationAllowed ?? false;
      this.NewNotificationConfiguration.PushPriorityLevel = value.PushPriorityLevel || 'normal';
      this.NewNotificationConfiguration.RequiresAcknowledgement = value.RequiresAcknowledgement ?? false;
      this.NewNotificationConfiguration.ExpiryDurationHours = value.ExpiryDurationHours ?? null;
      this.NewNotificationConfiguration.IsDefault = value.IsDefault ?? false;
      this.NewNotificationConfiguration.CronExpression = value.CronExpression || "";
      this.NewNotificationConfiguration.ScheduleTimeZone = value.ScheduleTimeZone || "";
      this.NewNotificationConfiguration.ScheduleActive = value.ScheduleActive ?? false;

      this.GetAllWhatsAppTemplateList();

      this.logger.debug('Edit configuration loaded', {
        configurationId: value.ConfigurationId,
        categoryType: this.NewNotificationConfiguration.CategoryType,
        notificationType: this.NewNotificationConfiguration.NotificationType,
        subType: this.NewNotificationConfiguration.SubType
      });
    }
  }

  handleCancel(): void {
    this.isVisible = false;
    this.resetForm();
  }

  // Helper method to reset form to clean state
  resetForm(): void {
    // Create completely new instance to avoid any reference issues
    this.NewNotificationConfiguration = new NotificationTemplateConfiguration();

    // Explicitly set all form fields to ensure clean state
    this.NewNotificationConfiguration.CategoryType = "";
    this.NewNotificationConfiguration.NotificationType = "";
    this.NewNotificationConfiguration.SubType = "";
    this.NewNotificationConfiguration.DisplayName = "";
    this.NewNotificationConfiguration.Description = "";
    this.NewNotificationConfiguration.InternalAllowed = true;
    this.NewNotificationConfiguration.ExternalAllowed = false;
    this.NewNotificationConfiguration.CustomerAllowed = false;
    this.NewNotificationConfiguration.EventAllowed = true;
    this.NewNotificationConfiguration.SchedulingAllowed = false;
    this.NewNotificationConfiguration.OnDemandAllowed = true;
    this.NewNotificationConfiguration.SchedulingRequired = false;
    this.NewNotificationConfiguration.SortOrder = 0;
    this.NewNotificationConfiguration.PushNotificationAllowed = false;
    this.NewNotificationConfiguration.PushPriorityLevel = 'normal';
    this.NewNotificationConfiguration.RequiresAcknowledgement = false;
    this.NewNotificationConfiguration.ExpiryDurationHours = null;
    this.NewNotificationConfiguration.IsDefault = false;
    this.NewNotificationConfiguration.CronExpression = "";
    this.NewNotificationConfiguration.ScheduleTimeZone = "";
    this.NewNotificationConfiguration.ScheduleActive = false;

    this.logger.debug('Form reset to clean state');
  }

  GetAllWhatsAppTemplateList() {
    let url = this.ApiUrl + "notificationconfig/getwhatsapptemplate";

    this.logger.api("request", "notificationconfig/getwhatsapptemplate", {
      operation: "GetAllWhatsAppTemplateList"
    });

    this.http.get<WhatsAppTemplateList[]>(url).subscribe({
      next: (res) => {
        this.WhatsAppTemplateList = res;
        this.logger.api("response", "notificationconfig/getwhatsapptemplate", {
          status: 200,
          count: res.length
        });
      },
      error: (error) => {
        this.count++;
        this.logger.api("error", "notificationconfig/getwhatsapptemplate", {
          error,
          attempt: this.count
        });
        if (this.count < 2) {
          this.GetAllWhatsAppTemplateList();
        }
      }
    });
  }

  // Hierarchical dropdown methods
  onCategoryTypeChange(categoryType: string) {
    this.logger.debug('Category type changed', {
      from: this.NewNotificationConfiguration.CategoryType,
      to: categoryType
    });

    // Immediately clear dependent fields to prevent conflicts
    this.NewNotificationConfiguration.NotificationType = "";
    this.NewNotificationConfiguration.SubType = "";

    // Update the category type
    this.NewNotificationConfiguration.CategoryType = categoryType;

    this.logger.debug('Category type change completed', {
      categoryType: this.NewNotificationConfiguration.CategoryType,
      notificationType: this.NewNotificationConfiguration.NotificationType,
      subType: this.NewNotificationConfiguration.SubType
    });
  }

  onNotificationTypeChange(notificationType: string) {
    this.logger.debug('Notification type changed', {
      from: this.NewNotificationConfiguration.NotificationType,
      to: notificationType
    });

    // Immediately clear dependent SubType field
    this.NewNotificationConfiguration.SubType = "";

    // Update the notification type
    this.NewNotificationConfiguration.NotificationType = notificationType;

    this.logger.debug('Notification type change completed', {
      notificationType: this.NewNotificationConfiguration.NotificationType,
      subType: this.NewNotificationConfiguration.SubType,
      shouldShowSubType: this.shouldShowSubType()
    });
  }

  getFilteredNotificationTypes(): { value: string, label: string }[] {
    const categoryType = this.NewNotificationConfiguration.CategoryType;
    if (!categoryType || !this.notificationTypeOptions[categoryType]) {
      return [];
    }
    return this.notificationTypeOptions[categoryType];
  }

  getFilteredSubTypes(): { value: string, label: string }[] {
    const categoryType = this.NewNotificationConfiguration.CategoryType;
    const notificationType = this.NewNotificationConfiguration.NotificationType;

    if (!categoryType || !notificationType) {
      return [];
    }

    const key = `${categoryType}-${notificationType}`;
    return this.subTypeOptions[key] || [];
  }

  shouldShowSubType(): boolean {
    const notificationType = this.NewNotificationConfiguration.NotificationType;
    // Show SubType dropdown for notification types that have subtypes
    return notificationType === 'Reports' || notificationType === 'PurchaseOrderApproval';
  }

  // Human-readable description of the config-level schedule CRON (shown under the
  // Schedule input when Scheduling Allowed is on). Empty when no CRON is entered.
  get cronScheduleDescription(): string {
    const cron = this.NewNotificationConfiguration?.CronExpression?.trim();
    if (!cron) {
      return '';
    }
    try {
      return cronstrue.toString(cron);
    } catch {
      return 'Invalid CRON expression';
    }
  }

  // Enhanced validation for hierarchical structure
  Validate(model: NotificationTemplateConfiguration) {
    var Isvalid: boolean = true;

    if (!model.CategoryType || model.CategoryType.trim() === "") {
      this.alertService.error("Category Type is required");
      Isvalid = false;
    }

    if (!model.NotificationType || model.NotificationType.trim() === "") {
      this.alertService.error("Notification Type is required");
      Isvalid = false;
    }

    // Check if SubType is required for the selected notification type
    const requiresSubType = model.NotificationType === 'Reports' ||
      model.NotificationType === 'OrderStatus' ||
      model.NotificationType === 'MachineAlert' ||
      model.NotificationType === 'PurchaseOrderApproval';

    if (requiresSubType && (!model.SubType || model.SubType.trim() === "")) {
      this.alertService.error(`Sub Type is required for ${model.NotificationType}`);
      Isvalid = false;
    }

    if (!model.DisplayName || model.DisplayName.trim() === "") {
      this.alertService.error("Display Name is required");
      Isvalid = false;
    }

    // Config-level schedule: when the schedule is active, a CRON is mandatory.
    if (model.SchedulingAllowed && model.ScheduleActive) {
      const cron = model.CronExpression?.trim();
      if (!cron) {
        this.alertService.error("Schedule (CRON) is required when Schedule Active is on");
        Isvalid = false;
      } else {
        try {
          cronstrue.toString(cron);
        } catch {
          this.alertService.error("Schedule (CRON) expression is invalid");
          Isvalid = false;
        }
      }
    }

    return Isvalid;
  }

  // Debug method to verify form state (can be removed in production)
  debugFormState(): void {
    this.logger.debug('Current form state', {
      categoryType: this.NewNotificationConfiguration.CategoryType,
      notificationType: this.NewNotificationConfiguration.NotificationType,
      subType: this.NewNotificationConfiguration.SubType,
      displayName: this.NewNotificationConfiguration.DisplayName,
      availableNotificationTypes: this.getFilteredNotificationTypes().length,
      availableSubTypes: this.getFilteredSubTypes().length,
      shouldShowSubType: this.shouldShowSubType()
    });
  }

  // Method to ensure form is completely isolated from table data
  ensureFormIsolation(): void {
    // Verify that NewNotificationConfiguration is not referencing any table data
    const isIsolated = !this.NotificationConfigurationList.some(item =>
      item === this.NewNotificationConfiguration
    );

    if (!isIsolated) {
      this.logger.warn('Form isolation compromised, resetting form');
      this.resetForm();
    }
  }
}
